import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconVolumeDown: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconVolumeDown"><Path d="M22.5 12H15.5M1.5 7.5H6L12.5 3.75V20.25L6 16.5H1.5V7.5Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconVolumeDown;
